import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import { UnorderedListElement } from '~/components/organism/PluginsEditor/types';
import serialize from './serialize';

export type Props = RenderElementProps & {
  element: UnorderedListElement;
};

const UnorderedList: React.FCC<Props> = ({
  dataTestId,
  attributes,
  element,
  children,
}) => (
  <Container data-testid={dataTestId} {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.ul<{}>`
  margin: 0;
`;

export default {
  nodeName: 'UL',
  renderComponent: props => <UnorderedList {...props} />,
  deserialize: () => ({ type: ELEMENTS.UL }),
  serialize,
};
